import { get, post } from './http'
//语言[zh,en,kr]

/*首页-----------------------------------------------------------------------------*/
/**
 * getBannerList，获取banner图
 * @param language:语言
 * @param channel:HOME->首页
 */
export const getBannerList = p => get('/api/web/home/getBannerList', p)
/**
 * getColumnList，获取栏目列表
 * @param language 语言
 * @param columnType 热点:hotspot，最新活动:news，入门必备:tiro，进阶玩法:advanced
 * @param game 游戏类型
 */
export const getColumnList = p => get('/api/web/game/getColumnList', p)
/**
 * getHomeArticlesList，首页推荐资讯列表接口
 * @param language 语言
 */
export const getHomeArticlesList = p => get('/api/web/home/getHomeArticlesList', p)
/**
 * getPartnerList，首页战略伙伴
 */
export const getPartnerList = p => get('/api/web/home/getPartnerList', p)


/*资讯-----------------------------------------------------------------------------*/
/**
 * getTagList，首页更多资讯列表接口
* @param language 语言
 */
export const getTagList = p => get('/api/web/home/getTagList', p)
/**
 * getArticlesList，首页更多资讯列表接口
 * @param tagIds 标签
* @param language 语言
* @param pageNo 页数
* @param pageSize 页条数
 */
export const getArticlesList = p => get('/api/web/home/getArticlesList', p)


/*资讯详情-----------------------------------------------------------------------------*/
/**
 * articlesDetail，前端资讯详情接口
 * @param id:主键ID
 */
export const articlesDetail = p => get('/api/web/home/articlesDetail', p)

/*游戏详情-----------------------------------------------------------------------------*/
/**
 * articlesDetail，前端资讯详情接口
 * @param language:语言
 * @param game:游戏编码
 */
export const getGameDetail = p => get('/api/web/game/getGameDetail', p)

/*订阅-----------------------------------------------------------------------------*/
/**
 * subscribePost，输入邮箱订阅
 * @param email:邮件
 */
export const subscribePost = p => post('/api/web/home/submitEmail', p)





// wap端




// WEBPACK FOOTER //
// ./src/request/api.js